import { Component } from '@angular/core';
import { AvanoMessage, AvanoMessageType } from '../avano-toaster.interfaces';

export const AVANO_TOASTER_KEY = 'avano-toaster'

@Component({
  selector: 'avano-toaster',
  templateUrl: './avano-toaster.component.html',
  styleUrls: ['./avano-toaster.component.scss']
})
export class AvanoToasterComponent {
  templateTypes: { message: { $implicit: AvanoMessage } }
  toasterKey = AVANO_TOASTER_KEY;

  messageTypes = AvanoMessageType;
}
